
import * as React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { graphql } from "gatsby"
import { Row, Col, Button, Carousel } from "react-bootstrap"
import "./accomm-deferred.scss"
import Layout from "../components/layout"
import Seo from "../components/seo" 
 
export const query = graphql`
query AccommDeferredQuery($slug: String!) {
	hygraph {
		accomodationOptionses(where: {slug: $slug}) {
			id
			slug
			accommodationsBedroomCount
			accommodationsLocationIdentifier
			accommodationsGalleryImages {
				id
				imageAltText
				imagePhoto {
					url
					urlSharp {
					  childImageSharp {
						gatsbyImageData(placeholder: BLURRED, quality: 60, formats: [AUTO, WEBP])
					  }
					}
				  }
			}
			accommodationsModalDescription {
				html
			}
		}
	}
}
  
`
const AccommDeferred = ({data, index}) => {
    //console.log({data});
	const accomDeferredContent = data.hygraph.accomodationOptionses;

    return (
        <Layout>
		
		{ accomDeferredContent?.map((accomDefMap, index) => {
        return (
		<div key={index}>

            <Seo title={accomDefMap.accommodationsBedroomCount +' '+ accomDefMap.accommodationsLocationIdentifier + ' in Sapphire Beach Resort Belize'} />
            <div className="accomm-deferred">
                <Row>
                    
                    <Col sm={{ span:5, order: 'last' }} xs={{ order: 'last' }} id="right">
                        <div className="text-field"  key={index}>
                            <h2>{accomDefMap.accommodationsBedroomCount}</h2>
                            <h2>{accomDefMap.accommodationsLocationIdentifier}</h2>
                            <div dangerouslySetInnerHTML={{ __html: accomDefMap.accommodationsModalDescription.html }} />
                        </div>

                        <div className="contact-button">
                        <a href="https://hotels.cloudbeds.com/reservation/YaTJuM/" referrer="noreferrer">
                            <Button id="button-one-color">
                                <h4>I'm Ready to Book</h4>
                            </Button>
                        </a>
                        </div>

                        <div className="rewards-accom">
                            <h4>Receive cash back by booking directly through our Sapphire website.</h4>
                            <a href="/rewards"><h5>Learn More</h5></a>
                        </div>
                    </Col>

                    <Col sm={{ span:7, order: 'first' }} xs={{ order: 'first' }} id="left">
                        <div className="image-gallery">
                            <Carousel fade>
							
							{accomDefMap.accommodationsGalleryImages?.map((blockMap, index) => {
								const image = getImage(blockMap.imagePhoto.urlSharp);
          					return (
                                <Carousel.Item key={index}>
                                    <GatsbyImage image={image} 
                                        alt={blockMap.imageAltText} />
                                </Carousel.Item>
                            )})}

                            </Carousel>                            
                        </div>

                    </Col>

                    
                </Row>
            </div>

		</div>
		)})}
        </Layout>
       );
    };
    
export default AccommDeferred;
